/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var proto = globalObject && globalObject.Element ? Element.prototype : {
  matches: function matches() {
    return false;
  }
};
var vendor = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
var _default = match;
exports.default = _default;
function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i] == el) return true;
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/matchesSelector.js
// module id = 143
// module chunks = 0